export default __webpack_public_path__ + "static/media/p-6-desktop.83bf44e9.png";